import * as React from 'react';

export default {
  Logout: React.lazy(
    () =>
      import(
        /* webpackChunkName: "logout" */
        './Logout'
      ),
  ),
  Projects: React.lazy(
    () =>
      import(
        /* webpackChunkName: "projects" */
        './Projects'
      ),
  ),
  ProjectSettings: React.lazy(
    () =>
      import(
        /* webpackChunkName: "project-settings" */
        './Projects/Settings'
      ),
  ),
  NotFound: React.lazy(
    () =>
      import(
        /* webpackChunkName: "not-found" */
        './NotFound'
      ),
  ),
  UserProfile: React.lazy(
    () =>
      import(
        /* webpackChunkName: "user-profile" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './UserProfile'
      ),
  ),
  ManageAccount: React.lazy(
    () =>
      import(
        /* webpackChunkName: "manage-account" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './Accounts/ManageAccount'
      ),
  ),
  CreateAccount: React.lazy(
    () =>
      import(
        /* webpackChunkName: "create-account" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './Accounts/CreateAccount'
      ),
  ),
  AccountAuditing: React.lazy(
    () =>
      import(
        /* webpackChunkName: "account-auditing" */
        './Accounts/Auditing'
      ),
  ),
  PatientDetail: React.lazy(
    () =>
      import(
        /* webpackChunkName: "patient-detail" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './PatientDetail'
      ),
  ),
  Usage: React.lazy(
    () =>
      import(
        /* webpackChunkName: "usage" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './Accounts/Usage'
      ),
  ),
  Groups: React.lazy(
    () =>
      import(
        /* webpackChunkName: "groups" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './Accounts/Groups'
      ),
  ),
  Billing: React.lazy(
    () =>
      import(
        /* webpackChunkName: "billing" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './Accounts/Billing'
      ),
  ),
  ClientsV2: React.lazy(
    () =>
      import(
        /* webpackChunkName: "clientsv2" */
        './Accounts/ClientsV2'
      ),
  ),
  Users: React.lazy(
    () =>
      import(
        /* webpackChunkName: "users" */
        './Accounts/Users'
      ),
  ),
  Tasks: React.lazy(
    () =>
      import(
        /* webpackChunkName: "tasks" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './Tasks'
      ),
  ),
  GenomicsDashboard: React.lazy(
    () =>
      import(
        /* webpackChunkName: "genomics-dashboard" */
        './Genomics/Dashboard'
      ),
  ),
  GenomicsTests: React.lazy(
    () =>
      import(
        /* webpackChunkName: "genomics-tests" */
        './Genomics/Tests'
      ),
  ),
  GenomicsTestDetails: React.lazy(
    () =>
      import(
        /* webpackChunkName: "genomics-tests-details" */
        './Genomics/TestDetails'
      ),
  ),
  GenomicsIngestions: React.lazy(
    () =>
      import(
        /* webpackChunkName: "genomics-ingestions" */
        './Genomics/Ingestions'
      ),
  ),
  GenomicsActions: React.lazy(
    () =>
      import(
        /* webpackChunkName: "genomics-actions" */
        './Genomics/Actions'
      ),
  ),
  AddGenomicsAction: React.lazy(
    () =>
      import(
        /* webpackChunkName: "genomics-actions-add" */
        './Genomics/Actions/Add'
      ),
  ),
  TaskView: React.lazy(
    () =>
      import(
        /* webpackChunkName: "task-view" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './Tasks/View'
      ),
  ),
  Invitations: React.lazy(
    () =>
      import(
        /* webpackChunkName: "invitations" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './Invitations'
      ),
  ),
  AccessControl: React.lazy(
    () =>
      import(
        /* webpackChunkName: "access-control" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './Accounts/AccessControl'
      ),
  ),
  AccessControlV2: React.lazy(
    () =>
      import(
        /* webpackChunkName: "access-control-v2" */
        './Accounts/AccessControlV2'
      ),
  ),
  EducationContent: React.lazy(
    () =>
      import(
        /* webpackChunkName: "education-content" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './EducationContent'
      ),
  ),
  ApiKeys: React.lazy(
    () =>
      import(
        /* webpackChunkName: "api-keys" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './Accounts/ApiKeys'
      ),
  ),
  Home: React.lazy(
    () =>
      import(
        /* webpackChunkName: "home" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './Home'
      ),
  ),
  ManageProjects: React.lazy(
    () =>
      import(
        /* webpackChunkName: "manage-projects" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './ManageProjects'
      ),
  ),
  Cohorts: React.lazy(
    () =>
      import(
        /* webpackChunkName: "cohorts" */
        './Cohorts'
      ),
  ),
  Features: React.lazy(
    () =>
      import(
        /* webpackChunkName: "trial-matching-config" */
        './Accounts/Features'
      ),
  ),
  GeneSets: React.lazy(
    () =>
      import(
        /* webpackChunkName: "gene-sets" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './ProjectKnowledge/GeneSets'
      ),
  ),
  ProjectTags: React.lazy(
    () =>
      import(
        /* webpackChunkName: "project-tags" */
        './ProjectKnowledge/Tags'
      ),
  ),
  ManageConsent: React.lazy(
    () =>
      import(
        /* webpackChunkName: "manage-consent" */
        '@lifeomic/phc-web-toolkit/src/components/ManageConsent'
      ),
  ),
  Consent: React.lazy(
    () =>
      import(
        /* webpackChunkName: "consent" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './Consent'
      ),
  ),
  SurveysList: React.lazy(
    () =>
      import(
        /* webpackChunkName: "surveys-list" */
        '@lifeomic/phc-web-toolkit/src/components/ManageSurveys/SurveysList'
      ),
  ),
  SurveyDetails: React.lazy(
    () =>
      import(
        /* webpackChunkName: "survey-details" */
        '@lifeomic/phc-web-toolkit/src/components/ManageSurveys/SurveyDetails'
      ),
  ),
  SurveyResponse: React.lazy(
    () =>
      import(
        /* webpackChunkName: "survey-response" */
        '@lifeomic/phc-web-toolkit/src/components/ManageSurveys/SurveyResponse'
      ),
  ),
  AddData: React.lazy(
    () =>
      import(
        /* webpackChunkName: "add-data" */
        './AddData'
      ),
  ),
  CustomApps: React.lazy(
    () =>
      import(
        /* webpackChunkName: "custom-apps" */
        './CustomApps'
      ),
  ),
  ManageCircles: React.lazy(
    () =>
      import(
        /* webpackChunkName: "manage-circles" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './ManageCircles'
      ),
  ),
  ManageEHRs: React.lazy(
    () =>
      import(
        /* webpackChunkName: "manage-ehrs" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './Accounts/ManageEHRs'
      ),
  ),
  EHRDetail: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ehr-detail" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './Accounts/ManageEHRs/EHRDetail'
      ),
  ),
  SubjectSearch: React.lazy(
    () =>
      import(
        /* webpackChunkName: "subject-search" */
        './SubjectSearch'
      ),
  ),
  SFTP: React.lazy(
    () =>
      import(
        /* webpackChunkName: "files-sftp" */
        './Files/SFTP'
      ),
  ),
  SFTPUser: React.lazy(
    () =>
      import(
        /* webpackChunkName: "files-sftp-user" */
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        './Files/SFTP/User'
      ),
  ),
  FileTransfer: React.lazy(
    () =>
      import(
        /* webpackChunkName: "files-transfer" */
        './Files/Transfer'
      ),
  ),
  ProjectLandingPage: React.lazy(
    () =>
      import(
        /* webpackChunkName: "project-landing-page" */
        './Projects/LandingPage'
      ),
  ),
  OntologiesLocalCodeSystems: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ontologies-local-codeSystems" */
        './Ontologies/Local/CodeSystems'
      ),
  ),
  OntologiesLocalCodeSystem: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ontologies-local-codeSystem" */
        './Ontologies/Local/CodeSystems/CodeSystem'
      ),
  ),
  OntologiesLocalValueSets: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ontologies-local-valueSets" */
        './Ontologies/Local/ValueSets'
      ),
  ),
  OntologiesLocalValueSet: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ontologies-local-valueSet" */
        './Ontologies/Local/ValueSets/ValueSet'
      ),
  ),
  OntologiesMarketplaceCodeSystems: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ontologies-marketplace-codeSystems" */
        './Ontologies/Marketplace/CodeSystems'
      ),
  ),
  OntologiesMarketplaceCodeSystem: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ontologies-marketplace-codeSystem" */
        './Ontologies/Marketplace/CodeSystems/CodeSystem'
      ),
  ),
  OntologiesMarketplaceValueSets: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ontologies-marketplace-valueSets" */
        './Ontologies/Marketplace/ValueSets'
      ),
  ),
  OntologiesMarketplaceValueSet: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ontologies-marketplace-valueSet" */
        './Ontologies/Marketplace/ValueSets/ValueSet'
      ),
  ),
  TrialMatching: React.lazy(
    () =>
      import(
        /* webpackChunkName: "trial-matching" */
        './TrialMatching'
      ),
  ),
  ContentManagement: React.lazy(
    () =>
      import(
        /* webpackChunkName: "content-management" */
        './ContentManagement'
      ),
  ),
  EMAs: React.lazy(
    () =>
      import(
        /* webpackChunkName: "emas" */
        './EMAs'
      ),
  ),
  Marketplace: React.lazy(
    () =>
      import(
        /* webpackChunkName: "embedded-marketplace" */
        './Marketplace'
      ),
  ),
  Reseller: React.lazy(
    () =>
      import(
        /* webpackChunkName: "reseller" */
        './Reseller'
      ),
  ),
  OnboardingSnapshot: React.lazy(
    () =>
      import(
        /* webpackChunkName: "onboarding-snapshot" */
        './OnboardingSnapshot'
      ),
  ),
  FileValidation: React.lazy(
    () =>
      import(
        /* webpackChunkName: "file-validation" */
        './FileValidation'
      ),
  ),
  RegenerativeMedicineOps: React.lazy(
    () =>
      import(
        /* webpackChunkName: "regenerative-medicine-ops" */
        './RegenerativeMedicineOps'
      ),
  ),
  ReportTemplates: React.lazy(
    () =>
      import(
        /* webpackChunkName: "report-templates" */
        './ReportTemplates'
      ),
  ),
  PrintZoriReport: React.lazy(
    () =>
      import(
        /* webpackChunkName: "print-zori-report" */
        './Print/ZoriReport'
      ),
  ),
  ZoomAppointments: React.lazy(
    () =>
      import(
        /* webpackChunkName: "zoom-appointments" */
        './ZoomAppointments'
      ),
  ),
  AIRules: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ai-rules" */
        './AIRules'
      ),
  ),
  ZoriChat: React.lazy(
    () =>
      import(
        /* webpackChunkName: "zori-chat" */
        './ZoriChat'
      ),
  ),
  Employees: React.lazy(
    () =>
      import(
        /* webpackChunkName: "employees" */
        './Employees'
      ),
  ),
};
